// extracted by mini-css-extract-plugin
export default {"buttonAction":"AuthLayoutSubmitButton_buttonAction__QlJA3","button":"AuthLayoutSubmitButton_button__Ipso6","buttons":"AuthLayoutSubmitButton_buttons__OP+aw"};